<template>
    <div class="setting-page">
        <div class="setting-page-inner">
            <div class="side-nav">
                <ul>
                    <li>
                        <router-link to="/setting/bind"><span class="iconfont icon-lianjie"></span>账户绑定</router-link>
                    </li>
                    <li>
                        <router-link to="/setting/message"><span class="iconfont icon-tongzhi"></span>通知提醒</router-link>
                    </li>
                    <li>
                        <router-link to="/setting/private"><span class="iconfont icon-lock"></span>隐私设置</router-link>
                    </li>
                </ul>
            </div>
            <router-view class="setting-router" />
        </div>
    </div>
</template>

<script>
import { defineComponent, onMounted } from "vue";
import config from "../../until/configs";

export default defineComponent({
    setup() {
        onMounted(()=>{
            document.title = config.siteTitle;
        })
    }
})
</script>

<style lang="scss" scoped>
@import '../../scss/setting.scss';
</style>
<style lang="scss">
@import '../../scss/setting-router.scss';
</style>